import { Action, ActionReducer } from '@ngrx/store';
import { toJsonString } from '@util/object';
import { Config } from '@util/persist-reducer/config';
import * as R from 'ramda';

const INIT_ACTION = '@ngrx/store/init';
const UPDATE_ACTION = '@ngrx/store/update-reducers';

const returnStateFromLocalStorage: any = (_, stateFromLocalStorage) => stateFromLocalStorage;

export const persistReducer = <S, T = S, A extends Action = Action>(
  {
    storageKey,
    pullInitialState = true,
    shouldSync = R.T,
    shouldReinitialize = R.F,
    mergeStates = returnStateFromLocalStorage,
    mapper = R.identity as any,
    storage = localStorage
  }: Config<S, T>,
  reducer: ActionReducer<S, A>
): ActionReducer<S, A> => (state: S, action: A) => {
  const isInitializationCall = R.isNil(state);
  const isInitializationAction = action.type === INIT_ACTION || action.type === UPDATE_ACTION;
  const initialState = isInitializationCall ? reducer(state, action) : state;
  const shouldInitialize = pullInitialState && isInitializationAction;

  if (shouldInitialize || shouldReinitialize(state, action)) {
    const stateFromLocalStorage = JSON.parse(storage.getItem(storageKey));
    return stateFromLocalStorage
      ? mergeStates(initialState, stateFromLocalStorage)
      : initialState;
  }

  const nextState = reducer(initialState, action);
  const shouldSyncState = shouldSync(state, action);

  if (shouldSyncState) {
    const stateToSync = mapper(nextState);
    storage.setItem(storageKey, toJsonString(stateToSync));
  }

  return nextState;
};
